<p>logs-user-log works!</p>
